export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_ID
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const STRIPE_TABLE_ID=process.env.REACT_APP_STRIPE_TABLE_ID;